import React, { useState, useEffect } from "react";
import api from "../../api/axios"; // ✅ axios personnalisé
import { Grid, Button } from "@mui/material";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const Estimates = () => {
  const [estimates, setEstimates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchEstimates = async () => {
      setLoading(true);
      try {
        const response = await api.get("/quickbooks/estimates/");
        console.log("Estimate -> ", response.data.estimates.QueryResponse.Estimate);

        const estimateRows = response.data.estimates.QueryResponse.Estimate.map((estimate) => ({
          id: estimate.id,
          clientName: estimate.clientName,
          totalAmount: estimate.totalAmount,
          status: estimate.status,
        }));

        setEstimates(estimateRows);
      } catch (err) {
        console.error("Failed to fetch estimates:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEstimates();
  }, []);

  const columns = [
    { Header: "Client Name", accessor: "clientName", align: "left" },
    { Header: "Total Amount", accessor: "totalAmount", align: "left" },
    { Header: "Status", accessor: "status", align: "left" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container justifyContent="flex-end">
          <Button variant="contained" color="primary">
            Add Estimate
          </Button>
        </Grid>
        <MDBox pt={3}>
          <DataTable table={{ columns, rows: estimates }} isLoading={loading} noEndBorder />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default Estimates;
